var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractBronze2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 323 323",
    style: {
      enableBackground: "new 0 0 323 323"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#575651;stroke-width:6.8176;}\r\n\t.st1{fill:#575651;}\r\n\t.st2{fill:#DE996F;}\r\n\t.st3{fill:none;stroke:#575651;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,45.4h165c3.6,0,6.6,3,6.6,6.6v220c0,3.6-3,6.6-6.6,6.6H79c-3.6,0-6.6-3-6.6-6.6V52 C72.4,48.4,75.4,45.4,79,45.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.7,146.5h132.9c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H95.7c-2.2,0-4-1.8-4-4l0,0 C91.7,148.3,93.5,146.5,95.7,146.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,186.5h132.9c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H96c-2.2,0-4-1.8-4-4l0,0C92,188.2,93.8,186.5,96,186.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.7,126.1h132.9c2.2,0,4,1.8,4,4v0c0,2.2-1.8,4-4,4H95.7c-2.2,0-4-1.8-4-4v0 C91.7,127.9,93.5,126.1,95.7,126.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,166h132.9c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H96c-2.2,0-4-1.8-4-4l0,0C92,167.8,93.8,166,96,166z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,206h132.9c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H96c-2.2,0-4-1.8-4-4l0,0C92,207.8,93.8,206,96,206z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,106h133c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H96c-2.2,0-4-1.8-4-4l0,0C92,107.8,93.8,106,96,106z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96,85h131c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H96c-2.2,0-4-1.8-4-4l0,0C92,86.8,93.8,85,96,85z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.8,64.7h28.4c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-28.4c-2.2,0-4-1.8-4-4l0,0 C192.9,66.5,194.6,64.7,196.8,64.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112,240c0.1,2.8,1.5,5.6,3.5,7.6c1.9,1.9,4.5,1.1,6.5-0.1c1.1-0.7,2-1.6,2.9-2.5c1-1,2.4-1.7,3.8-2.1 c3-1,6.5-0.8,8.8,1.5c1.2,1.2,1.7,2.6,2.7,3.9c1.1,1.5,2.7,2.5,4.4,3.2c1.7,0.7,3.5,1,5.3,1.1c2,0.1,4.2,0.4,6.1-0.1 c2.5-0.7,4-3,5.8-4.7c2.7-2.6,7.5-5.8,11.4-4.1c2.1,0.9,3.8,2.3,5.8,3.2c2.3,1,4.8,1.2,7.2,1.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.8,230.5l91.1-74.2c3.6-2.9,8.9-2.4,11.9,1.2c2.9,3.6,2.4,8.9-1.2,11.9l-91.1,74.2L210.8,230.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.2,231.6l11.2,13.6l-22.2,6L209.2,231.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractBronze2);
export default __webpack_public_path__ + "static/media/contract-bronze-2.91ff1e111151ff9ecfd76a6bb682a3fd.svg";
export { ForwardRef as ReactComponent };